import type { PaginatedResponse } from '../types/common';
import type { CreateInvitationRequest, Invitation, User } from '../types/user';
import { request } from './apiClient';

export function getUsers(): Promise<PaginatedResponse<User>> {
  return request<PaginatedResponse<User>>('/api/admin/users');
}

export function getInvitations(): Promise<PaginatedResponse<Invitation>> {
  return request<PaginatedResponse<Invitation>>('/api/admin/invitations');
}

export function createInvitation(invitation: CreateInvitationRequest): Promise<Invitation> {
  return request<Invitation>('/api/admin/invitations', {
    method: 'POST',
    body: JSON.stringify(invitation),
  });
}

export function revokeInvitation(invitationId: string): Promise<Invitation> {
  return request<Invitation>(`/api/admin/invitations/${encodeURIComponent(invitationId)}/revoke`, {
    method: 'POST',
  });
}

export function deleteInvitation(invitationId: string): Promise<void> {
  return request(`/api/admin/invitations/${encodeURIComponent(invitationId)}`, {
    method: 'DELETE',
    expectNoContent: true,
  });
}

export function updateUserStatus(userId: string, active: boolean): Promise<User> {
  return request<User>(`/api/admin/users/${encodeURIComponent(userId)}`, {
    method: 'PATCH',
    body: JSON.stringify({ active }),
  });
}
